export default __webpack_public_path__ + "static/media/IoTDevice.44e3183f.svg";